import { Chip, CircularProgress, Grid } from "@material-ui/core"
import { useEffect, useState } from "react"
import React from 'react'

export const EagleEmAnalise = ({
  handleRefresh,
  status,
  backgroundColor,
  intervalTime = 30000
}) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const interval = setInterval(async () => {
      setLoading(true)
      await handleRefresh()
      setLoading(false)
    }, intervalTime)

    return () => {
      clearInterval(interval)
    }
  }, [])

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item>
        <Chip
          label={status}
          style={{
            backgroundColor,
            color: '#fff'
          }}
        />
      </Grid>
      <Grid item>{loading && <CircularProgress size={12} />}</Grid>
    </Grid>
  )
}
